var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.766,
    height: 12.201,
    viewBox: "0 0 12.766 12.201",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "linkedin",
    d: "M2.9,4.433V12.67H.158V4.433H2.9ZM3.075,1.89A1.316,1.316,0,0,1,2.655,2.9a1.567,1.567,0,0,1-1.126.407H1.513A1.5,1.5,0,0,1,.416,2.9,1.362,1.362,0,0,1,0,1.89,1.339,1.339,0,0,1,.428.872a1.564,1.564,0,0,1,1.118-.4,1.52,1.52,0,0,1,1.105.4A1.387,1.387,0,0,1,3.075,1.89Zm9.691,6.059V12.67H10.032V8.265A2.4,2.4,0,0,0,9.7,6.9,1.183,1.183,0,0,0,8.644,6.4a1.346,1.346,0,0,0-.877.287,1.768,1.768,0,0,0-.528.711,2.007,2.007,0,0,0-.091.673v4.6H4.413q.017-3.316.017-5.377t-.008-2.46l-.008-.4H7.148v1.2H7.131a3.638,3.638,0,0,1,.341-.466,3.528,3.528,0,0,1,.47-.432,2.164,2.164,0,0,1,.723-.362,3.272,3.272,0,0,1,.951-.128,2.952,2.952,0,0,1,2.286.943,3.96,3.96,0,0,1,.865,2.764Z",
    transform: "translate(0 -0.469)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.56030e1a90f4976dac3d6bd593ef7798.svg";
export { ForwardRef as ReactComponent };